<div class="monitoring-alert-container">
  <button class="btn btn-link alert-button-icon" (click)="showAlertTooltip()">
    <svg role="img" viewBox="0 0 8 8">
      <title>{{ 'label_monitoring_alerts' | translate }}</title>
      <use xlink:href="#bell"></use>
    </svg>
  </button>
  @if (displayTooltip) {
    <div class="monitoring-label-tooltip px-3 py-1 small">
      <strong>{{ 'label_monitoring_alert' | translate }}</strong>
      @if (isAlertArray) {
        <div data-e2e-id="monitoring-alert">
          @for (alertMessage of alerts; track alertMessage) {
            <p class="margin-bottom-xs">{{ alertMessage }}</p>
          }
        </div>
      }
    </div>
  }
</div>
